window.angular.module('MyHippoProducer.Components').component('policyHeader', {
    restrict: 'E',
    scope: {},
    transclude: true,
    templateUrl: 'components/policy-header/policy-header.html',
    controller: function ($scope, $state, PolicyService) {
        $scope.policyService = PolicyService;
    }
});
